@let item1Image = data.items[0]!.image!;
@let item2Image = data.items[1]!.image!;
@let item3Text = data.items[2]!.text!;
@let item4Image = data.items[3]!.image!;
@let item5Image = data.items[4]?.image!;
@let item6Image = data.items[5]?.image!;
@let item7Image = data.items[6]?.image!;

<div class="centered-with-padding mx-auto py-7">
  <div class="flex flex-col gap-y-5 desk:gap-y-4">
    @if (data.title; as title) {
      <app-title [title]="title" size="h2" />
    }

    @if (data.description; as description) {
      <span>{{ description }}</span>
    }
  </div>
  <div class="grid grid-cols-2 gap-1 pt-7 desk:grid-cols-3 desk:gap-3">
    <div class="group h-[293px] overflow-hidden rounded-3xl desk:order-1 desk:h-[508px]">
      @if (item1Image) {
        <app-image
          class="cursor-zoom-in"
          (click)="zoomImageRequested.emit(item1Image)"
          [hoverEffect]="true"
          [image]="item1Image"
          [isPriority]="!isImageInPreviousBlocks"
          [pregenerationSize]="{ width: 352, height: 508, exact: 'desk' }" />
      }
    </div>

    <div class="group h-[293px] overflow-hidden rounded-3xl desk:order-2 desk:col-span-2 desk:h-[508px]">
      @if (item2Image) {
        <app-image
          class="cursor-zoom-in"
          (click)="zoomImageRequested.emit(item2Image)"
          [hoverEffect]="true"
          [image]="item2Image"
          [isPriority]="!isImageInPreviousBlocks"
          [pregenerationSize]="{ width: 716, height: 508, exact: 'desk' }" />
      }
    </div>

    <div class="flex h-[293px] flex-col gap-1 desk:order-5 desk:h-auto">
      <div
        class="flex h-[calc(50%-.125rem)] flex-col justify-center gap-2 rounded-3xl bg-anis p-6 text-center desk:aspect-square desk:h-auto desk:gap-9">
        @if (item3Text?.title; as title) {
          <app-title [title]="title" size="custom-15" />
        }
        @if (item3Text?.subtitle; as subtitle) {
          <span class="text-[10px] font-bold leading-[14px] desk:text-[14px] desk:leading-[19px]">{{ subtitle }}</span>
        }
      </div>
      <div class="group h-[calc(50%-.125rem)] overflow-hidden rounded-3xl desk:hidden">
        @if (item4Image) {
          <app-image
            class="cursor-zoom-in"
            (click)="zoomImageRequested.emit(item4Image)"
            [hoverEffect]="true"
            [image]="item4Image"
            [pregenerationSize]="{ width: 173, height: 145 }" />
        }
      </div>
    </div>

    <div
      class="group h-[293px] overflow-hidden rounded-3xl desk:order-3 desk:row-span-1 desk:aspect-square desk:h-auto">
      @if (item5Image) {
        <app-image
          class="cursor-zoom-in"
          (click)="zoomImageRequested.emit(item5Image)"
          [hoverEffect]="true"
          [image]="item5Image"
          [pregenerationSize]="{ width: 352, height: 352, exact: 'desk' }" />
      }
    </div>

    <div class="group hidden overflow-hidden rounded-3xl desk:order-4 desk:block desk:aspect-square">
      @if (item4Image) {
        <app-image
          class="cursor-zoom-in"
          (click)="zoomImageRequested.emit(item4Image)"
          [hoverEffect]="true"
          [image]="item4Image"
          [pregenerationSize]="{ width: 352, height: 352, exact: 'desk' }" />
      }
    </div>

    @if (!data.hideLastItem) {
      <div class="group h-[293px] overflow-hidden rounded-3xl desk:order-6 desk:col-span-2 desk:h-[508px]">
        @if (item6Image) {
          <app-image
            class="cursor-zoom-in"
            (click)="zoomImageRequested.emit(item6Image)"
            [hoverEffect]="true"
            [image]="item6Image"
            [pregenerationSize]="{ width: 716, height: 508, exact: 'desk' }" />
        }
      </div>

      <div class="group h-[293px] overflow-hidden rounded-3xl desk:order-7 desk:h-[508px]">
        @if (item7Image) {
          <app-image
            class="cursor-zoom-in"
            (click)="zoomImageRequested.emit(item7Image)"
            [hoverEffect]="true"
            [image]="item7Image"
            [pregenerationSize]="{ width: 352, height: 508, exact: 'desk' }" />
        }
      </div>
    }
  </div>
</div>
